// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b708cfcf","455":"66e432e6","977":"958a3a30"}[chunkId] + ".chunk.js";
};